import './Switch.less'
import Switch from './Switch'

export type { SwitchProps } from './iSwitch'

export default Switch
